import { NighteyesJWT } from "../types/login";

export const ParseJwt: (rawToken: string) => NighteyesJWT | undefined = (rawToken) => {
  try {
    return JSON.parse(atob(rawToken.split(".")[1])) as NighteyesJWT;
  } catch (e) {
    return undefined;
  }
};
